import React, { useState, useCallback } from 'react';
import { IoClose } from "react-icons/io5";

export const UploadModal = ({ isOpen, onClose }) => {
    const [previewImages, setPreviewImages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = useCallback((e) => {
        const files = Array.from(e.target.files);
        setPreviewImages([]);
        
        files.forEach((file, index) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                setPreviewImages(prev => [...prev, {
                    src: event.target.result,
                    file: file,
                    index: index
                }]);
            };
            reader.readAsDataURL(file);
        });
    }, []);

    const removeImage = useCallback((indexToRemove) => {
        setPreviewImages(prev => {
            const newPreviews = prev.filter((_, index) => index !== indexToRemove);
            // Reassign indices after removal
            return newPreviews.map((item, index) => ({
                ...item,
                index: index
            }));
        });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const formData = new FormData();
            previewImages.forEach(({ file }) => {
                formData.append('image', file);
            });

            const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/upload', {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                alert('Upload successful!');
                setPreviewImages([]);
                onClose();
            } else {
                alert(`Upload failed: ${data.error}`);
            }
        } catch (error) {
            alert('Upload failed: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content-upload">
                <div className="modal-header">
                    <h2>Upload Images on the system</h2>
                    <button 
                        className="close-button" 
                        onClick={onClose}
                    >
                        <IoClose size={24} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="form-group">
                        <label htmlFor="upload-images">Images:</label>
                        <input
                            type="file"
                            id="upload-images"
                            onChange={handleFileChange}
                            accept="image/*"
                            multiple
                            className="file-input"
                            required
                        />
                    </div>

                    {previewImages.length > 0 && (
                        <div className="preview-grid">
                            {previewImages.map((preview, index) => (
                                <div key={index} className="preview-item">
                                    <img 
                                        src={preview.src} 
                                        alt={`Preview ${index + 1}`} 
                                        className="preview-image"
                                    />
                                    <button
                                        type="button"
                                        className="remove-preview"
                                        onClick={() => removeImage(index)}
                                    >
                                        ×
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="modal-actions">
                        <button 
                            type="submit" 
                            className="upload-submit-btn"
                            disabled={isLoading || previewImages.length === 0}
                        >
                            {isLoading ? 'Uploading...' : 'Upload'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};